import { render, staticRenderFns } from "./RecaptchTest.vue?vue&type=template&id=69adbb16&scoped=true&"
import script from "./RecaptchTest.vue?vue&type=script&lang=js&"
export * from "./RecaptchTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69adbb16",
  null
  
)

export default component.exports